import { z } from 'zod'
import { DEFAULT_CUSTOMER_SEARCH } from '@/features/master-data/const/customer-list-search.ts'
import { createdAtSearchShape, createdAtSortSearchShape, creatorMemberSearchShape } from '@/utils/list-query.ts'

export const customerSearchSchema = z.object({
  current: z.coerce.number().int().min(1).catch(DEFAULT_CUSTOMER_SEARCH.current),
  pageSize: z.coerce.number().int().min(1).max(100).catch(DEFAULT_CUSTOMER_SEARCH.pageSize),
  id: z.coerce.number().int().positive().optional().catch(undefined),
  wecomBindingStatus: z.enum(['bound', 'unbound']).optional().catch(undefined),
  collectionBillGroupingDay: z.coerce.number().int().min(1).max(28).optional().catch(undefined),
  keyword: z.string().trim().max(255).optional().catch(undefined),
  noteKeyword: z.string().trim().max(1000).optional().catch(undefined),
  tagIds: z.array(z.coerce.number().int().positive()).max(50).optional().catch(undefined),
  ...creatorMemberSearchShape,
  ...createdAtSearchShape,
  ...createdAtSortSearchShape,
  salespersonId: z.coerce.number().int().positive().optional().catch(undefined),
  status: z.enum(['enabled', 'disabled']).optional().catch(undefined)
})

export type CustomerListSearch = z.infer<typeof customerSearchSchema>

export { DEFAULT_CUSTOMER_SEARCH } from '@/features/master-data/const/customer-list-search.ts'

// 新建、编辑页通过历史状态保存列表返回位置，避免污染表单 URL。
declare module '@tanstack/react-router' {
  interface HistoryState {
    customerListReturnSearch?: CustomerListSearch
  }
}
